function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2008(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 23.51,
    height: 9.31,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.16375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.755,
    y: 4.655
  }, "\n        Hamilton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 9.31,
    width: 23.51,
    height: 23.47,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.93375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.755,
    y: 21.045
  }, "\n        Schuyler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 32.78,
    width: 23.51,
    height: 28.05,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.702
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.755,
    y: 46.805
  }, "\n        Yates\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 60.83,
    width: 23.51,
    height: 30.4,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.702
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.755,
    y: 76.03
  }, "\n        Lewis\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 91.23,
    width: 23.51,
    height: 39.3,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.6122222222222224
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.755,
    y: 110.88
  }, "\n        Schoharie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 130.53,
    width: 23.51,
    height: 40.23,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.9183333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.755,
    y: 150.645
  }, "\n        Seneca\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 170.76,
    width: 23.51,
    height: 45.26,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.358571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.755,
    y: 193.39
  }, "\n        Orleans\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 216.02,
    width: 23.51,
    height: 47.81,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.93875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.755,
    y: 239.925
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 263.83,
    width: 23.51,
    height: 48.21,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.358571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.755,
    y: 287.935
  }, "\n        Wyoming\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 312.05,
    width: 23.51,
    height: 50.23,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.93875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.755,
    y: 337.165
  }, "\n        Allegany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 362.28,
    width: 23.51,
    height: 50.75,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.702
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.755,
    y: 387.655
  }, "\n        Essex\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 413.03,
    width: 23.51,
    height: 55.06,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.351
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.755,
    y: 440.55999999999995
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 468.08,
    width: 23.51,
    height: 55.64,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.93875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.755,
    y: 495.9
  }, "\n        Delaware\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 523.73,
    width: 23.51,
    height: 56.89,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.93875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.755,
    y: 552.1750000000001
  }, "\n        Chenango\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 580.62,
    width: 23.51,
    height: 59.56,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.9183333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.755,
    y: 610.4
  }, "\n        Fulton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 640.18,
    width: 23.51,
    height: 59.82,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.93875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.755,
    y: 670.0899999999999
  }, "\n        Cortland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.51,
    y: 0,
    width: 33.96,
    height: 42.19,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.66
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 40.49,
    y: 21.095
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57.47,
    y: 0,
    width: 35.18,
    height: 42.19,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.036
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 75.06,
    y: 21.095
  }, "\n        Tioga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 92.65,
    y: 0,
    width: 39.13,
    height: 42.19,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.9130000000000003
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 112.215,
    y: 21.095
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 131.78,
    y: 0,
    width: 39.72,
    height: 42.19,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.62
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 151.64,
    y: 21.095
  }, "\n        Otsego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 171.5,
    y: 0,
    width: 40.87,
    height: 42.19,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.838571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 191.935,
    y: 21.095
  }, "\n        Genesee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 212.36,
    y: 0,
    width: 41.34,
    height: 42.19,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.1675
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 233.03000000000003,
    y: 21.095
  }, "\n        Herkimer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 253.7,
    y: 0,
    width: 45.32,
    height: 42.19,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.027142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 276.36,
    y: 21.095
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 299.02,
    y: 0,
    width: 45.85,
    height: 42.19,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.218999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 321.945,
    y: 21.095
  }, "\n        Livingston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 344.87,
    y: 0,
    width: 47.42,
    height: 42.19,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.27375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 368.58,
    y: 21.095
  }, "\n        Sullivan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 392.29,
    y: 0,
    width: 47.8,
    height: 42.19,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.27375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 416.19,
    y: 21.095
  }, "\n        Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 440.09,
    y: 0,
    width: 49.03,
    height: 42.19,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.031666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 464.60499999999996,
    y: 21.095
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 489.12,
    y: 0,
    width: 49.6,
    height: 42.19,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.8354545454545454
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 513.92,
    y: 21.095
  }, "\n        Cattaraugus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 538.72,
    y: 0,
    width: 50.7,
    height: 42.19,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.027142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 564.07,
    y: 21.095
  }, "\n        Clinton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 589.42,
    y: 0,
    width: 51.74,
    height: 42.19,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.031666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 615.29,
    y: 21.095
  }, "\n        Cayuga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 641.16,
    y: 0,
    width: 58.84,
    height: 42.19,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.027142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 670.5799999999999,
    y: 21.095
  }, "\n        Chemung\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.51,
    y: 42.19,
    width: 62.66,
    height: 39.81,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.423333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.84,
    y: 62.095
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.51,
    y: 82,
    width: 62.66,
    height: 42.02,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.404
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.84,
    y: 103.01
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.51,
    y: 124.03,
    width: 62.66,
    height: 42.31,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.5258333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.84,
    y: 145.185
  }, "\n        St._Lawrence\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.51,
    y: 166.34,
    width: 62.66,
    height: 42.91,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.13
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.84,
    y: 187.79500000000002
  }, "\n        Steuben\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.51,
    y: 209.25,
    width: 62.66,
    height: 43.57,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.44625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.84,
    y: 231.035
  }, "\n        Tompkins\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.51,
    y: 252.82,
    width: 62.66,
    height: 48.37,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.061666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.84,
    y: 277.005
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.51,
    y: 301.19,
    width: 62.66,
    height: 50.53,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.421666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.84,
    y: 326.455
  }, "\n        Oswego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.51,
    y: 351.71,
    width: 62.66,
    height: 52.24,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.4628571428571435
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.84,
    y: 377.83
  }, "\n        Ontario\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.51,
    y: 403.95,
    width: 62.66,
    height: 60.18,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.018
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.84,
    y: 434.03999999999996
  }, "\n        Chautauqua\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.51,
    y: 464.13,
    width: 62.66,
    height: 71.51,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.696363636363636
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.84,
    y: 499.885
  }, "\n        Schenectady\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.51,
    y: 535.64,
    width: 62.66,
    height: 75.75,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.266
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.84,
    y: 573.515
  }, "\n        Rensselaer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.51,
    y: 611.39,
    width: 62.66,
    height: 88.61,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.443333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.84,
    y: 655.6949999999999
  }, "\n        Ulster\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.17,
    y: 42.19,
    width: 68.02,
    height: 83.79,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.336666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 120.18,
    y: 84.08500000000001
  }, "\n        Broome\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 154.2,
    y: 42.19,
    width: 72.26,
    height: 83.79,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.043333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 190.32999999999998,
    y: 84.08500000000001
  }, "\n        Oneida\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 226.45,
    y: 42.19,
    width: 72.95,
    height: 83.79,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.421428571428573
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 262.925,
    y: 84.08500000000001
  }, "\n        Niagara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 299.41,
    y: 42.19,
    width: 85.29,
    height: 83.79,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.47375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 342.055,
    y: 84.08500000000001
  }, "\n        Saratoga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 384.7,
    y: 42.19,
    width: 101.23,
    height: 83.79,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.47375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 435.315,
    y: 84.08500000000001
  }, "\n        Rockland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 485.93,
    y: 42.19,
    width: 101.31,
    height: 83.79,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.47375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 536.585,
    y: 84.08500000000001
  }, "\n        Dutchess\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 587.24,
    y: 42.19,
    width: 112.76,
    height: 83.79,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.965000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 643.62,
    y: 84.08500000000001
  }, "\n        Albany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.17,
    y: 125.98,
    width: 142.43,
    height: 68.46,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.409999999999998
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 157.385,
    y: 160.21
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.17,
    y: 194.44,
    width: 142.43,
    height: 75.04,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.38
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 157.385,
    y: 231.96
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.17,
    y: 269.48,
    width: 142.43,
    height: 98.31,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.28875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 157.385,
    y: 318.635
  }, "\n        Onondaga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.17,
    y: 367.79,
    width: 142.43,
    height: 160.44,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 23.738333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 157.385,
    y: 448.01
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.17,
    y: 528.23,
    width: 142.43,
    height: 171.77,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 28.486
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 157.385,
    y: 614.115
  }, "\n        Bronx\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 228.6,
    y: 125.98,
    width: 130.63,
    height: 202.86,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.875454545454545
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 293.91499999999996,
    y: 227.41000000000003
  }, "\n        Westchester\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 359.23,
    y: 125.98,
    width: 139.79,
    height: 202.86,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 34.9475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 429.125,
    y: 227.41000000000003
  }, "\n        Erie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 499.02,
    y: 125.98,
    width: 200.98,
    height: 202.86,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 33.49666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 599.51,
    y: 227.41000000000003
  }, "\n        Nassau\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 228.6,
    y: 328.84,
    width: 224.61,
    height: 182.81,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 30.468333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 340.905,
    y: 420.245
  }, "\n        Queens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 228.6,
    y: 511.65,
    width: 224.61,
    height: 188.35,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 26.907142857142855
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 340.905,
    y: 605.8249999999999
  }, "\n        Suffolk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 453.21,
    y: 328.84,
    width: 246.79,
    height: 173.63,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 21.70375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 576.605,
    y: 415.655
  }, "\n        New_York\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 453.21,
    y: 502.47,
    width: 246.79,
    height: 197.53,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 39.506
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 576.605,
    y: 601.235
  }, "\n        Kings\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2008);
export default __webpack_public_path__ + "static/media/2008.8125ba71b439473673a29ed5fda48ab7.svg";
export { ForwardRef as ReactComponent };